<template>
  <div class="spelling_card d_card_slim margin-bottom-25" :class="{ active: currentSpellingTooltip === index - 1 }">
    <div @click="onClick" style="text-decoration: none; height: 100%">
      <div class="d-flex flex-row align-items-center" style="height: 100%">
        <div class="index_result">{{ index }}</div>
        <div class="margin-left-10">
          <div class="spelling_card_mistake">
            <span>{{ spelling_detail.word }} </span>
            <FAIcon icon="fas fa-arrow-right" />
            <span v-if="spelling_detail.edit === ''" style="color: #6c757d"> không có gợi ý</span>
            <span v-else style="color: #008615"> {{ listEditWords }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'SpellingCardDetail',
  components: { FAIcon },
  props: ['spelling_detail', 'index'],
  methods: {
    onClick() {
      this.$store.dispatch(
        'docRes/spelling/updateCurrentSpellingTooltip',
        this.currentSpellingTooltip === this.index - 1 ? -1 : this.index - 1
      )
      console.log('spelling detail: ', this.spelling_detail)

      const currentPageContainer = document.getElementById(`page-${this.currentPage}-container`)
      currentPageContainer.scrollIntoView({
        behavior: 'auto',
        inline: 'center',
      })
      currentPageContainer.parentElement.scrollTo(0, currentPageContainer.parentElement.scrollTop + this.spelling_detail.top)

      document.getElementById(`page-preview-${this.currentPage}`).scrollIntoView({
        behavior: 'auto',
        inline: 'center',
      })
    },
  },
  computed: {
    listEditWords() {
      let result = ''
      if (this.spelling_detail.edit) {
        this.spelling_detail.edit.forEach((word) => {
          result = result + word + ', '
        })
      }
      return result.substring(0, result.length - 2)
    },
    currentPage() {
      return this.$store.getters['docRes/spelling/currentSpellingPageDetail']
    },
    currentSpellingTooltip() {
      return this.$store.getters['docRes/spelling/currentSpellingTooltip']
    },
  },
}
</script>

<style scoped>
.spelling_card {
  cursor: pointer;
}

.spelling_card_mistake {
  font-size: 16px;
  margin: 0;
  color: #ff0000;
}

.spelling_card_mistake span {
  font-size: 16px;
}

.index_result {
  font-size: 18px;
  color: #6c757d;
  min-width: 80px;
  text-align: center;
}

.spelling_card.d_card_slim {
  border-left: 2px solid #ff0000;
  height: 60px;
  border-top: 1px solid #ececec;
}

.detail-view-icon {
  float: right;
  width: 40px;
  height: 40px;
  background-color: #007bff;
  text-align: center;
  vertical-align: middle;
}

.active {
  background-color: #f2f2f2;
}
</style>
